import { gql } from '@apollo/client/core';

export const CREATE_CONTACT = gql`
  mutation CreateContact($data: ContactInput!) {
    createContact(data: $data) {
      documentId
    }
  }
`;
